import React, { Component } from 'react';
import { connect } from 'react-redux';
import { openDrawer, closeDrawer } from 'actions/drawer';
import { openModal } from 'actions/modal';
import { addNotification } from 'actions/notifications';

import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import { firebaseConnect, helpers } from 'react-redux-firebase';
const { isLoaded, dataToJS, pathToJS } = helpers;
import { VisibleOnlyAdmin, VisibleOnlyCustomer } from 'components/AuthenticatedComponent';
import ContentHeader from 'components/ContentHeader';
import Button from 'components/Button';
import ProductPanel from 'components/ProductPanel';
import ProductViewPanel from 'components/ProductViewPanel';
import ProductList from 'components/ProductList/ProductList';
import Footer from 'components/AppFooter/AppFooter'

import Loader from 'components/Loader/Loader';

import { Product } from 'models';
import { validateProduct } from 'models/validate';

class Products extends Component {

	constructor (props) {
		super(props);
		this.state = {};
	}

	createProduct () {
		if(this.props.profile.role !== 'admin') {
			return;
		}
		this.props.openDrawer(<ProductPanel
			product={{}}
			addProduct={this.addProduct.bind(this)}
		/>);
	}

	addProduct (product, event) {
		//event.stopPropagation();
		//event.preventDefault();
		if(this.props.profile.role !== 'admin') {
			return;
		}

		const { firebase } = this.props;
		product["active"] = true;
		firebase.push('/products', product);
	}

	saveProduct (product) {
		if(this.props.profile.role !== 'admin') {
			return;
		}
		const { firebase } = this.props;
		firebase.set(`/products/${product.id}`, product).then( (res)=> {
		});
	}

	editProduct (product) {
		if(this.props.profile.role === 'admin') {
            this.props.openDrawer(<ProductPanel
                product={product}
                editing={true}
                saveProduct={this.saveProduct.bind(this)}
            />);
		}
		else{
            this.props.openDrawer(<ProductViewPanel
                product={product}
                editing={true}
                saveProduct={this.saveProduct.bind(this)}
            />);
        }



	}

    deactivateProduct (product, event) {
		event.stopPropagation();
		event.preventDefault();

		if(this.props.profile.role !== 'admin') {
			return;
		}

		this.props.openModal(null, {
			message : 'Are you sure you want to deactivate this Product?',
			title : 'Deactivate Product',
            actionBtnText : 'Deactivate',
				onClose : (result) => {
					if(result === true) {
						//var fileId = product.cover;
						const { firebase } = this.props;
                        firebase.update(`/products/${product.id}`, {'active': false});
					}
				}
			});
	}

	activateProduct (product, event) {
		event.stopPropagation();
		event.preventDefault();

		if(this.props.profile.role !== 'admin') {
			return;
		}

		this.props.openModal(null, {
			message : 'Are you sure you want to activate this Product?',
			title : 'Activate Product',
            actionBtnText : 'Activate',
				onClose : (result) => {
					if(result === true) {
						const { firebase } = this.props;
                        firebase.update(`/products/${product.id}`, {'active': true});
					}
				}
			});
	}

	render () {
		if(!isLoaded(this.props.products) || !isLoaded(this.props.files)) {
			return (
				<div className="main-content-area">
					<div className="page-content">
						<Loader color="main" size="large" />
					</div>
				</div>
			);
		}

        let button = (<VisibleOnlyAdmin><Button
			label="Create Product"
			onClick={this.createProduct.bind(this)}
		/></VisibleOnlyAdmin>);

		return (
			<ReactCSSTransitionGroup
				transitionName="main-content"
				transitionAppear={true}
				transitionAppearTimeout={1500}
				transitionEnterTimeout={1500}
				transitionLeaveTimeout={1500}
				className="main-transition-wrap"
			>
			<div className="main-content-area" key="products">
				<ContentHeader
					title="Products"
					button={button}
				/>

				<div className="page-content padded-top">
					<div className="container">
						<ProductList
							products={this.props.products}
							files={this.props.files}
							profile={this.props.profile}
							createProduct={this.createProduct.bind(this)}
							editProduct={this.editProduct.bind(this)}
							deactivateProduct={this.deactivateProduct.bind(this)}
							activateProduct={this.activateProduct.bind(this)}
						/>
					</div>
					<Footer/>
				</div>
			</div>
			</ReactCSSTransitionGroup>
		);
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		openDrawer :  (panel) => { dispatch(openDrawer(panel)); },
		closeDrawer : () => { dispatch(closeDrawer()); },
		openModal : (modal, props) => { dispatch(openModal(modal, props)); },
		addNotification : (key, message) => { dispatch(addNotification(key, message)); }
	};
};

const fbWrappedComponent = firebaseConnect( ({auth, profile}) => {

    if (!profile) {
        return [];
    } else if (profile.customer) {
        return [
            {
                path: 'products',
                storeAs: 'products',
                queryParams: [`orderByChild=active`, `equalTo=true`, 'notParsed']
            },
            {
                path: 'files',
                storeAs: 'files'
            }
        ];;
    } else if (profile.role === 'admin') {
        return [
            {
                path: 'products',
                storeAs: 'products'
            },
            {
                path: 'files',
                storeAs: 'files'
            }
        ];;
    }

})(Products);

//Auth
const connectAuth = connect(
    ({ firebase }) => {
        return{
            profile: pathToJS(firebase, 'profile'),
        };
    }
)(fbWrappedComponent);

export default connect(
	({ firebase }) => ({
		profile: pathToJS(firebase, 'profile'),
		products: dataToJS(firebase, 'products'),
		files: dataToJS(firebase, 'files')
	}),
	mapDispatchToProps
)(connectAuth);




// WEBPACK FOOTER //
// ./js/containers/Products/Products.js